// extracted by mini-css-extract-plugin
export var dotPulse = "Spinner-module--dotPulse--85507";
export var dotPulseAfter = "Spinner-module--dot-pulse-after--19537";
export var dotPulseBefore = "Spinner-module--dot-pulse-before--c9992";
export var dotPulseCore = "Spinner-module--dot-pulse-core--ca8a5";
export var stage = "Spinner-module--stage--9e84e";
export var withMessage = "Spinner-module--withMessage--3f569";